import React, { useState } from "react";
import { reallocate } from "../api";
import ConfirmPassword from "./ConfirmPassword";

/**
 * Manager badge that fd can edit in place. Non-admins never get the select.
 *
 * The change is written to username_override, so the spreadsheet's own value is
 * preserved and the reallocation survives the next import. Each change is
 * re-authenticated: a live session is not enough to move a partner's revenue.
 */
export default function ManagerCell({ row, dataset, managers, editable, label, onChange }) {
  const [pending, setPending] = useState(null);   // the username awaiting confirmation
  const [error, setError] = useState("");

  const imported = String(row.username_imported || row.username || "").toUpperCase();
  const current = String(row.username || "").toUpperCase();
  const overridden = Boolean(row.username_override);

  if (!editable) return <span className="badge">{current}</span>;

  const confirm = async (password) => {
    const { row: updated } = await reallocate(dataset, row.id, pending, password);
    onChange(row.id, updated);
    setPending(null);
    setError("");
  };

  const target = pending ? pending.toUpperCase() : "";

  return (
    <>
      <span
        className="mgr-cell"
        title={overridden ? `Reallocated from ${imported}` : "Reallocate to another manager"}
      >
        <select
          className={`mgr-select${overridden ? " is-overridden" : ""}`}
          value={row.username_override || ""}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => { setError(""); setPending(e.target.value); }}
        >
          <option value="">{imported}</option>
          {managers
            .filter((m) => m !== row.username_imported)
            .map((m) => <option key={m} value={m}>{m.toUpperCase()}</option>)}
        </select>
        {overridden && <span className="mgr-dot" aria-hidden />}
        {error && <span className="mgr-error" title={error}>!</span>}
      </span>

      <ConfirmPassword
        open={pending !== null}
        title={pending ? `Reallocate to ${target}` : "Reallocate"}
        detail={
          pending
            ? `${label || "This row"} moves from ${current} to ${target}.`
            : `${label || "This row"} reverts to ${imported} as imported.`
        }
        confirmLabel="Reallocate"
        onConfirm={confirm}
        onCancel={() => { setPending(null); setError(""); }}
      />
    </>
  );
}
